import { useAsyncJobsPolling, useRehydrateAsyncJobs } from '@hooks/index';

const AsyncJobsManager = () => {
  useRehydrateAsyncJobs();
  const { activeJobs, JobPoller } = useAsyncJobsPolling();

  return (
    <>
      {activeJobs.map(job => (
        <JobPoller key={job.id} jobId={job.id} />
      ))}
    </>
  );
};

export default AsyncJobsManager;
